import { render } from "./TariffsExpress.vue?vue&type=template&id=807560f2&scoped=true&ts=true"
import script from "./TariffsExpress.vue?vue&type=script&lang=ts"
export * from "./TariffsExpress.vue?vue&type=script&lang=ts"

import "./TariffsExpress.vue?vue&type=style&index=0&id=807560f2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807560f2"]])

export default __exports__